import * as React from "react";
export const HeadingName = (props) => React.createElement("div", { className: "rj-ev-list__heading-name", "data-uat": "div-ev-list-heading-name" }, props.name);
//# sourceMappingURL=HeadingName.js.map